export const blueNoiseTileCache = new Map<string, Float32Array>();
